<template>
    <div class="afu-border-b afu-border-solid afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-neutral afu-py-8">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Card',
    };
</script>
